<ng-container *ngFor="let entry of value; let i = index">
  <string-entry [(value)]="value[i]" (valueDeleted)="deleteValue($event)"></string-entry>
</ng-container>